import OnPremPortOpeningObject from '../../../models/entities/OnPremPortOpeningObject';

export type ObjColumn = {
	header: string;
	cell: (obj: OnPremPortOpeningObject) => string;
	limit?: number;
};

export const ObjectColumnsLayout:ObjColumn[] = [
	{
		header: 'Operation',
		cell: (obj: OnPremPortOpeningObject) => obj.operation?.name,
	},
	{
		header: 'Name',
		cell: (obj: OnPremPortOpeningObject) => obj.name,
		limit: 40,
	},
	{
		header: 'Object IPs',
		cell: (obj: OnPremPortOpeningObject) => obj.objectIPs,
		limit: 15,
	},
	{
		header: 'Object URLs',
		cell: (obj: OnPremPortOpeningObject) => obj.objectURLsFQDNs,
		limit: 15,
	},
	{
		header: 'Description',
		cell: (obj: OnPremPortOpeningObject) => obj.description,
		limit: 20,
	},
	{
		header: 'Nested Object',
		cell: (obj: OnPremPortOpeningObject) => obj.nestedObjects,
		limit: 20,
	}
];